export default __webpack_public_path__ + "maps-overview-quickstart-result-960-5267ef852f24c54f61e106be05085c3f.webp";